import { IApplication } from "@rentiohq/shared-frontend/dist/types/application.types";
import {
  Activities,
  Card,
  DisplayText,
  ESpacings,
} from "@rentiohq/web-shared/dist/components";
import { ts } from "services";

interface IProps {
  application: IApplication;
  setTab?: (tab: any) => void;
}

export const ApplicationDetailHistory = (props: IProps) => {
  const { application } = props;

  return (
    <Card
      space={ESpacings.base}
      heading={
        <DisplayText size="extraSmall" space="tight">
          {ts.system("history")}
        </DisplayText>
      }
    >
      <Activities
        identifier={`application-${application.id}`}
        filter={{
          where: {
            applicationId: application.id,
          },
        }}
        hasFetchMore={true}
        isCompact={true}
      />
    </Card>
  );
};
